import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  color: ${(props) => props.theme.main};
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  padding-bottom: 25px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: -20px;
  margin-right: -20px;
`

const Title = styled.h3`
  color: ${(props) => props.theme.main};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
  margin-top: 0px;
`

const Callout = ({ title, children }) => (
  <Wrapper>
    {title && <Title>{title}</Title>}
    {children}
  </Wrapper>
)

Callout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default Callout
